// Reads a design-token value for APIs that cannot take `var(--token)`, such as
// 2D canvas fill styles.
export function cssToken(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim()
}
